export default __webpack_public_path__ + "static/media/background.c3a1c8ea.svg";